import React, { useEffect, useState } from 'react';
import { ExternalLink, Video } from 'lucide-react';
import { camName } from '@/lib/tenerife';

const T = {
  es: { open: 'Abrir cámara', soon: 'Próximamente', live: 'LIVE' },
  en: { open: 'Open camera', soon: 'Coming soon', live: 'LIVE' },
  de: { open: 'Kamera öffnen', soon: 'Demnächst', live: 'LIVE' },
};

export const WebcamView = ({ cam, language = 'es' }) => {
  const t = T[language] || T.es;
  const [tick, setTick] = useState(Date.now());
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setFailed(false);
    const id = setInterval(() => setTick(Date.now()), 30000);
    return () => clearInterval(id);
  }, [cam?.id]);

  if (!cam) return null;
  const name = camName(cam, language);
  const isImage = cam.source_type === 'skyline' || cam.source_type === 'image';
  const src = cam.source_type === 'skyline'
    ? `${process.env.REACT_APP_BACKEND_URL}${cam.image_url}?t=${tick}`
    : cam.image_url;

  return (
    <div className="bg-white shadow-md overflow-hidden" data-testid="webcam-view">
      <div className="aspect-video bg-gray-900 relative">
        {isImage && !failed ? (
          <img
            key={cam.id}
            src={src}
            alt={`Webcam ${name}`}
            className="w-full h-full object-cover"
            onError={() => setFailed(true)}
            data-testid="webcam-image"
          />
        ) : cam.source_type === 'youtube' ? (
          <iframe
            src={`${cam.embed_url}?autoplay=0&mute=1`}
            width="100%" height="100%" frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen title={`Webcam ${name}`} className="w-full h-full"
            data-testid="webcam-iframe"
          />
        ) : (
          <div className="w-full h-full flex flex-col items-center justify-center text-gray-400">
            <Video size={44} className="mb-3 opacity-50" />
            <p className="text-sm">{t.soon}</p>
          </div>
        )}
        {isImage && !failed && (
          <div className="absolute top-3 left-3 flex items-center gap-1.5 bg-red-600 text-white px-2 py-1 text-xs font-bold" data-testid="webcam-live-badge">
            <span className="w-2 h-2 rounded-full bg-white animate-pulse" />
            {t.live}
          </div>
        )}
      </div>
      <div className="flex items-center justify-between px-4 py-3">
        <div className="min-w-0">
          <p className="font-bold text-[#1D1D1F] truncate" data-testid="webcam-name">{name}</p>
          <p className="text-xs text-gray-500">{cam.source_type === 'skyline' ? 'SkylineWebcams' : cam.source_type === 'youtube' ? 'YouTube' : ''}</p>
        </div>
        {cam.page_url && (
          <a
            href={cam.page_url} target="_blank" rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#38B2AC] hover:text-[#2C8F8A] transition-colors flex-shrink-0"
            data-testid="webcam-open-link"
          >
            {t.open} <ExternalLink size={14} />
          </a>
        )}
      </div>
    </div>
  );
};

export default WebcamView;
